import React from "react";

const Skeleton = ({ width = "100%", height = 14, radius, className = "" }) => (
  <span
    className={["cc-skeleton", className].filter(Boolean).join(" ")}
    style={{ width, height, borderRadius: radius }}
    aria-hidden="true"
  />
);

export const PageSkeleton = () => (
  <div className="cc-page" role="status" aria-label="Loading">
    <div className="cc-page-header">
      <div className="cc-page-header__text">
        <Skeleton width={120} height={12} />
        <Skeleton width={260} height={30} radius={10} />
      </div>
    </div>
    <div className="cc-grid">
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <Skeleton key={i} height={112} radius={18} />
      ))}
    </div>
  </div>
);

export default Skeleton;
